import React from "react";

function ShimmerComponent() {
  return (
    <div className="bg-black w-full h-screen  flex justify-center">
      <span className="loading loading-bars loading-lg"></span>
    </div>
  );
}

export default ShimmerComponent;
